const VIDEO_SELECTOR = 'video[data-ch-mirror-video]';

function playMirrorVideo(video) {
  if (!(video instanceof HTMLVideoElement)) return;

  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;

  if (video.readyState === 0) {
    video.load();
  }

  const playAttempt = video.play();

  if (playAttempt?.catch) {
    playAttempt.catch(() => {});
  }
}

function refreshMirrorVideos(root = document) {
  root.querySelectorAll(VIDEO_SELECTOR).forEach(playMirrorVideo);
}

function initMirrorVideos() {
  refreshMirrorVideos();

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playMirrorVideo(entry.target);
          }
        });
      },
      { rootMargin: '160px 0px' }
    );

    document.querySelectorAll(VIDEO_SELECTOR).forEach((video) => observer.observe(video));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMirrorVideos, { once: true });
} else {
  initMirrorVideos();
}

document.addEventListener('shopify:section:load', (event) => refreshMirrorVideos(event.target));
document.addEventListener('shopify:block:select', (event) => refreshMirrorVideos(event.target));
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    refreshMirrorVideos();
  }
});
